module.exports = __webpack_public_path__ + "static/media/heroicons_md-menu-alt-3.93aeb0a8.svg";